import { PillButton } from 'ui-kit/Buttons';

import RangeSlider from './RangeSlider';
import { usePopout, FloatingPortal } from '../hooks/usePopout';

export function RangePillButton(props: {
  min: number;
  max: number;
  name: string;
  initialValue: [number, number];
  onChange?: (values: [number, number]) => void;
  iconName: string;
  onIconClick?: () => void;
  displayPercentage?: boolean;
  inputFormat?: (value: string) => number;
  step?: number;
  integer?: boolean;
  decimal?: boolean;
  className?: string;
  displayFormat?: (value: number) => string;
}) {
  const { refs, getFloatingProps, getReferenceProps, isOpen, floatingStyles } = usePopout({
    offset: 2,
  });

  const displayFormat = props.displayFormat || ((value: number) => value.toString());
  const value = props.displayPercentage
    ? `${displayFormat(props.initialValue[0])}% to ${displayFormat(props.initialValue[1])}%`
    : `${props.initialValue[0]} to ${props.initialValue[1]}`;

  return (
    <>
      <PillButton
        {...getReferenceProps()}
        ref={refs.setReference}
        description={props.name}
        value={value}
        className={props.className || ''}
        iconName={props.iconName || 'pill-close'}
        iconOnClick={props.onIconClick}
      />

      {isOpen ? (
        <FloatingPortal>
          <div
            // border-gray-700/bg-gray-950 match every other flyout panel
            // and pill's own surface (was border-brand-500/bg-black — the
            // same panel-border/off-black mismatch fixed in
            // PillButtonCombobox and PillDropdown). z-40: above Pill's
            // remove-badge (z-30), below the app's modal/dialog tier (z-50).
            className="z-40 w-[300px] rounded-lg border border-solid border-gray-700 bg-gray-950 p-4"
            ref={refs.setFloating}
            style={floatingStyles}
            {...getFloatingProps()}
          >
            <RangeSlider
              defaultValue={props.initialValue}
              min={props.min}
              max={props.max}
              onChange={(sliderValues) => {
                props.onChange?.([sliderValues[0], sliderValues[1]]);
              }}
              displayFormat={displayFormat}
              inputFormat={props.inputFormat}
              displayPercentage={props.displayPercentage}
              step={props.step}
              integer={props.integer}
              decimal={props.decimal}
            />
          </div>
        </FloatingPortal>
      ) : null}
    </>
  );
}
